/**
 * ========================================
 * ADMIN PANEL ŞİFRE KONTROL BİLEŞENİ
 * ========================================
 * Admin panele giriş için şifre doğrulama ekranı
 */

import React, { useState } from 'react';
import './AdminPasswordCheck.css';

interface AdminPasswordCheckProps {
  onSuccess: () => void;
}

const ADMIN_PANEL_PASSWORD = 'Birbirbiribirine';

const AdminPasswordCheck: React.FC<AdminPasswordCheckProps> = ({ onSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [attempts, setAttempts] = useState(0);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (password === ADMIN_PANEL_PASSWORD) {
      // Şifre doğru - sessionStorage'a kaydet
      sessionStorage.setItem('adminPanelAccess', 'true');
      onSuccess();
    } else {
      setError('Yanlış şifre! Lütfen tekrar deneyin.');
      setAttempts(prev => prev + 1);
      setPassword('');

      // 3 yanlış denemeden sonra uyarı
      if (attempts >= 2) {
        setError('Çok fazla yanlış deneme! Lütfen sistem yöneticisi ile iletişime geçin.');
      }
    }
  };

  return (
    <div className="admin-password-overlay">
      <div className="admin-password-container">
        <div className="admin-password-header">
          <i className="bi bi-shield-lock-fill"></i>
          <h2>Admin Panel Erişimi</h2>
          <p>Admin panele erişmek için şifre giriniz</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-password-form">
          <div className="form-group">
            <label htmlFor="adminPassword">
              <i className="bi bi-key-fill me-2"></i>
              Şifre
            </label>
            <input
              type="password"
              id="adminPassword"
              className={`form-control ${error ? 'is-invalid' : ''}`}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              placeholder="Admin panel şifresini girin"
              autoFocus
              disabled={attempts >= 3}
            />
            {error && (
              <div className="error-message">
                <i className="bi bi-exclamation-circle-fill me-2"></i>
                {error}
              </div>
            )}
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={!password || attempts >= 3}
          >
            <i className="bi bi-arrow-right-circle me-2"></i>
            Giriş Yap
          </button>

          <div className="password-hint">
            <i className="bi bi-info-circle me-2"></i>
            Şifreyi unuttuysanız sistem yöneticisi ile iletişime geçin
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminPasswordCheck;
